<script setup lang="ts">
/**
 * Use params.
 */
const { config, set } = useParams()

/**
 * Translations.
 */
const { t } = useI18n()
</script>

<template>
    <div v-if="config.mode !== 'DATA'" class="absolute inset-0">
        <div
            class="absolute inset-0 flex h-full items-center justify-center gap-8"
        >
            <button
                class="bg-deep-blue rounded px-4 py-2 font-bold text-white"
                type="button"
                @click="set({ mode: 'DATA' })"
            >
                {{ t('open-world-panel') }}
            </button>
            <button
                class="bg-deep-blue rounded px-4 py-2 font-bold text-white"
                type="button"
                @click="set({ mode: 'DATA', country: 'FRA' })"
            >
                {{ t('open-country-panel') }}
            </button>
        </div>
    </div>
</template>